import { GlobalComponentService } from '@techmore/global';
import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import { MemberProxyService } from 'src/app/member/service/member-proxy.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MEMBER_LOGIN_WAY } from 'src/app/member/entity/member-login-way';
import { OAuthError } from 'src/app/share/entity/OauthError';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MemberPreferenceModalComponent } from '../member-preference-modal/member-preference-modal.component';
import { ServerConfigService } from 'src/app/share/service/server-config.service';

@Component({
  selector: 'app-member-loging-button',
  templateUrl: './member-loging-button.component.html',
  styleUrls: ['./member-loging-button.component.scss']
})
export class MemberLogingButtonComponent implements OnInit, OnDestroy {
  /** 會員偏好modal */
  @ViewChild(MemberPreferenceModalComponent, { static: false }) mpModal :MemberPreferenceModalComponent
  isBrowser: boolean;
  /** 到首頁的路徑 */
  toHomePath: string;
  /** 是否有設定會員登入機制 */
  hasLoginSys = false;
  /** 已登入的會員資料 */
  memberInfo: any;
  /** 正在以某種方式登入會員中 */
  loginIng = false;
  private _calHasMemberSubc: Subscription;
  private _memberInfSubc: Subscription;

  constructor(
    protected memberService: MemberProxyService,
    protected router: Router,
    protected route: ActivatedRoute,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected globalComponentService: GlobalComponentService,
    protected translateService: TranslateService,
    serverConfigService: ServerConfigService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.toHomePath = `/${serverConfigService.config.lang}`;
  }

  ngOnInit() {
    this._calHasMemberSubc = this.memberService.getHasLoginSystem$().subscribe(v => {
      this.hasLoginSys = v;
    });

    if (this.isBrowser) {
      this._memberInfSubc = this.memberService.getMemberInfo$().subscribe(info => {
        this.memberInfo = info;
      });

      this.memberService.getOnLoginStart$().subscribe(() => {
        this.loginIng = true;
      });

      this.memberService.getOnLoginEnd$().subscribe(() => {
        this.loginIng = false;
      });
    }
  }

  ngOnDestroy(): void {
    if (this._calHasMemberSubc) {
      this._calHasMemberSubc.unsubscribe();
    }
    if (this._memberInfSubc) {
      this._memberInfSubc.unsubscribe();
    }
  }

  openCultureCenterLogin() {
    if (!this.loginIng && !this.memberInfo) {
      this.memberService.login(MEMBER_LOGIN_WAY.CULTURE_CENTER).subscribe(v => {
      }, error => {
        console.error(error);
        try {
          if (error instanceof HttpErrorResponse) {
            let oauthError: OAuthError;
            oauthError = $.extend(new OAuthError(this.translateService), error.error);
            this.globalComponentService.openErrorAlert(oauthError.getMessage());
          } else {
            this.globalComponentService.openErrorAlert(error.message);
          }
        } catch (e2) {
          this.globalComponentService.openErrorAlert(error.message);
        }
      });
    }
  }

  logout() {
    this.memberService.logout().subscribe(v => { });
  }

  openPrefere() {
    this.mpModal.open();
  }
}
